'use client';

import React from "react";
import { AccountsPage } from "./AccountsPage";
import { AccountsContext, defaultCopy } from "./internals";
import { ToastProvider } from "./components/Toaster";

/**
 * @aumonline/light-accounts — portable Corporate Customers module.
 *
 * Host injects everything; this module imports nothing outside itself.
 *
 * Props:
 *  - storage:     LIGHT_ACCOUNTS_STORAGE_INTERFACE (required)
 *  - currentUser: { role }  — gates delete to owner/admin
 *  - copy:        optional copy overrides (industry flavouring)
 */
export const LightAccountsModule = ({ storage, currentUser, copy }) => {
  if (!storage) throw new Error("<LightAccountsModule> requires a `storage` prop.");
  const value = React.useMemo(
    () => ({
      storage,
      currentUser: currentUser || {},
      copy: { ...defaultCopy, ...(copy || {}) },
    }),
    [storage, currentUser, copy]
  );
  return (
    <AccountsContext.Provider value={value}>
      <ToastProvider>
        <AccountsPage />
      </ToastProvider>
    </AccountsContext.Provider>
  );
};

export default LightAccountsModule;
